import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import Toast from "react-bootstrap/Toast";

const ToastSide = () => (
    <div
        aria-live="polite"
        aria-atomic="true"
        style={{
            position: 'relative',
            minHeight: '200px',
        }}
    >
        <div
            style={{
                position: 'absolute',
                top: 0,
                right: 0,
            }}
        >
            <Toast>
                <Toast.Header>
                    <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
                    <strong className="mr-auto">Bootstrap</strong>
                    <small>just now</small>
                </Toast.Header>
                <Toast.Body>See? Just like this.</Toast.Body>
            </Toast>
            <Toast>
                <Toast.Header>
                    <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
                    <strong className="mr-auto">Bootstrap</strong>
                    <small>2 seconds ago</small>
                </Toast.Header>
                <Toast.Body>Heads up, toasts will stack automatically</Toast.Body>
            </Toast>
        </div>
    </div>
);

export default withRouter(connect(null)(ToastSide));
